import I_ORGANISATIONS_SET from "../services/api/interfaces/I_ORGANISATIONS";
import {
  REDUCER_ACTIONS,
} from '../contexts/global';
import {
  COLLABORATORS_FILTERS_REDUCER_ACTIONS,
  CUSTOMERS_FILTERS_REDUCER_ACTIONS,
  CHARGES_FILTERS_REDUCER_ACTIONS,
  ACTIVITIES_FILTERS_REDUCER_ACTIONS,
  PLANIFICATION_FILTERS_REDUCER_ACTIONS,
} from '../contexts/filters';
import {
  getDefaultUserOrganisation,
  isValidUserOrganisationSelections,
} from "./dataHelper";

/**
 *  Applique les organisations autorisees pour l'utilisateur, et celles selectionnees par defaut
 * @param param0
 */
export const applyUserOrganisations = ({
  organisationsSets,
  globalDispatch,

  collaboratorsFiltersState,
  collaboratorsFiltersDispatch,
  chargesFiltersState,
  chargesFiltersDispatch,
  activitiesFiltersState,
  activitiesFiltersDispatch,
  planificationFiltersState,
  planificationFiltersDispatch,
}:{
  organisationsSets: I_ORGANISATIONS_SET[],
  globalDispatch: any,
  collaboratorsFiltersState: any,
  collaboratorsFiltersDispatch: any,
  chargesFiltersState: any,
  chargesFiltersDispatch: any,
  activitiesFiltersState: any,
  activitiesFiltersDispatch: any,
  planificationFiltersState: any,
  planificationFiltersDispatch: any,
}) => {

  globalDispatch({type:REDUCER_ACTIONS.SET_ORGANISATIONS_SETS,payload:{organisationsSets}});

  // si les filtres organisations sont vides ou invalid, on leur colle les default

  // collabs
  if (!isValidUserOrganisationSelections({
    organisationsSets,key:'collaborators',selections: collaboratorsFiltersState.directions,
  })) {
    const {defaultDirection,defaultPole} = getDefaultUserOrganisation({organisationsSets,key: 'collaborators'});
    collaboratorsFiltersDispatch({type:COLLABORATORS_FILTERS_REDUCER_ACTIONS.SET_DIRECTIONS,payload:{directions: defaultDirection ? [defaultDirection.key] : []}});
    collaboratorsFiltersDispatch({type:COLLABORATORS_FILTERS_REDUCER_ACTIONS.SET_DIRECTION_POLES,payload:{directionPoles: defaultPole ? [defaultPole.key] : []}});
  }

  // charges
  if (!isValidUserOrganisationSelections({
    organisationsSets,key:'charges',selections: chargesFiltersState.directions_ops,
  })) {
    const {defaultDirection,defaultPole} = getDefaultUserOrganisation({organisationsSets,key: 'charges'});
    chargesFiltersDispatch({type:CHARGES_FILTERS_REDUCER_ACTIONS.SET_DIRECTIONS_OPS,payload:{directions_ops: defaultDirection ? [defaultDirection.key] : []}});
    chargesFiltersDispatch({type:CHARGES_FILTERS_REDUCER_ACTIONS.SET_HUBS_OPS,payload:{hubs_ops: defaultPole ? [defaultPole.key] : []}});
  }
  // if (!isValidUserOrganisationSelections({
  //   organisationsSets,key:'activities',selections: chargesFiltersState.directions_hr,
  // })) {
  //   const {defaultDirection,defaultPole} = getDefaultUserOrganisation({organisationsSets,key: 'activities'});
  //   chargesFiltersDispatch({type:CHARGES_FILTERS_REDUCER_ACTIONS.SET_DIRECTIONS_HR,payload:{directions_hr: defaultDirection ? [defaultDirection.key] : []}});
  //   chargesFiltersDispatch({type:CHARGES_FILTERS_REDUCER_ACTIONS.SET_HUBS_HR,payload:{hubs_hr: defaultPole ? [defaultPole.key] : []}});
  // }

  // activites
  if (!isValidUserOrganisationSelections({
    organisationsSets,key:'activities',selections: activitiesFiltersState.directions_hr,
  })) {
    const {defaultDirection,defaultPole} = getDefaultUserOrganisation({organisationsSets,key: 'activities'});
    // console.log('default for activities',{defaultDirection,defaultPole})
    activitiesFiltersDispatch({type:ACTIVITIES_FILTERS_REDUCER_ACTIONS.SET_DIRECTIONS_HR,payload:{directions_hr: defaultDirection ? [defaultDirection.key] : []}});
    activitiesFiltersDispatch({type:ACTIVITIES_FILTERS_REDUCER_ACTIONS.SET_HUBS_HR,payload:{hubs_hr: defaultPole ? [defaultPole.key] : []}});
  }

  // plan de charge
  if (!isValidUserOrganisationSelections({
    organisationsSets,key:'planification',selection: planificationFiltersState.direction,
  })) {
    const {defaultDirection,defaultPole} = getDefaultUserOrganisation({organisationsSets,key: 'planification'});
    planificationFiltersDispatch({type:PLANIFICATION_FILTERS_REDUCER_ACTIONS.SET_DIRECTION,payload:{direction: defaultDirection ? defaultDirection.key : ''}});
    planificationFiltersDispatch({type:PLANIFICATION_FILTERS_REDUCER_ACTIONS.SET_HUB,payload:{hub: defaultPole ? defaultPole.key : ''}});
  }

};
